import createModel from "../createModel";

export const UserConsent = createModel("UserConsent", (json) => ({
    date: json.BeginDate,
    idConsent: json.IdConsent,
    modifyDate: json.ModifyDate,
    consentUrl: json.ConsentURL,
}));
